/**
 * Who a post (or later: a comment) is sent as. The user themselves is always
 * available; an organization can only be selected when the user holds a role
 * in it (enforced by the selection sheet and the backend).
 */
export enum SenderType {
  USER = 'USER',
  ORGANIZATION = 'ORGANIZATION'
}

export type Sender =
  | { type: SenderType.USER }
  | { type: SenderType.ORGANIZATION; organizationId: string };
